import { useField } from '@unform/core';
import { CSSProperties, useEffect, useRef } from 'react';
import ReactSwitch, { ReactSwitchProps } from 'react-switch';
import * as S from './styles';

interface Props extends ReactSwitchProps {
  name: string;
  label?: string;
  containerStyle?: CSSProperties;
}

const SwitchSigle = ({ name, label, containerStyle, ...rest }: Props) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: ref => Number(ref.props.checked),
      ref: inputRef.current,
    });
  }, [fieldName, registerField]);

  return (
    <S.Label htmlFor={name} style={containerStyle}>
      <ReactSwitch
        id={name}
        name={name}
        handleDiameter={24}
        onColor="#80CA52"
        boxShadow="0px 1px 3px 1px rgba(0, 0, 0, 0.25)"
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      />
      {label && <span>{label}</span>}
    </S.Label>
  );
};

SwitchSigle.defaultProps = {
  containerStyle: {},
  label: '',
};

export default SwitchSigle;
